export default "__VITE_ASSET__da52e635__"